export default "__VITE_ASSET__DgDd6SF$__"